module.exports = __webpack_public_path__ + "imgs/twitter-color.019b0d57c71d26c16f62723c113db323.svg";